import { Col, Modal, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const AccountLocked = ({ visible, closeModal }) => {
  const { t } = useTranslation();

  return (
    <Modal visible={visible} closeModal={closeModal}>
      <Col pad="40px 24px">
        <Text h4 col={theme.SECONDARY} center>
          {t('auth.accountLocked')}
        </Text>

        <Text center marg="20px 20px 0">
          {t('auth.accountLockedDesc')}
        </Text>
      </Col>
    </Modal>
  );
};

export default AccountLocked;
